import React, {
    createContext,
    useContext,
    useMemo,
    useState,
} from 'react';
import PropTypes from 'prop-types';

const NOT_CONNECTED = Object.freeze({
    connectedOperator: false,
    setConnectedOperator: () => {},
});

const ConnectedOperatorContext = createContext(NOT_CONNECTED);

function ConnectedOperatorProvider({ children }) {
    const [connectedOperator, setConnectedOperator] = useState(false);
    const value = useMemo(
        () => ({ connectedOperator, setConnectedOperator }),
        [connectedOperator],
    );

    return (
        <ConnectedOperatorContext.Provider value={value}>
            {children}
        </ConnectedOperatorContext.Provider>
    );
}

ConnectedOperatorProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

function useConnectedOperator() {
    return useContext(ConnectedOperatorContext).connectedOperator;
}

function usePublishConnectedOperator() {
    return useContext(ConnectedOperatorContext).setConnectedOperator;
}

export {
    ConnectedOperatorContext,
    ConnectedOperatorProvider,
    useConnectedOperator,
    usePublishConnectedOperator,
};
